/*eslint-disable*/
/**
 * 将数值四舍五入(保留2位小数)后格式化成金额形式
 *
 * @param num 数值(Number或者String)
 * @return 金额格式的字符串,如'1234,567.45'
 * @type String
 */
function formatCurrency(num) {
  num = num.toString().replace(/\$|\,/g,'');
  if(isNaN(num))
    num = "0";
  let sign = (num == (num = Math.abs(num)));
  num = Math.floor(num*100+0.50000000001);
  let cents = num%100;
  num = Math.floor(num/100).toString();
  if(cents<10)
    cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
    num = num.substring(0,num.length-(4*i+3))+','+
      num.substring(num.length-(4*i+3));
  return (((sign)?'':'-') + num + '.' + cents);
}

export const veniceStartMoney = (state) =>{
  let num = state.colorStartMoney.toFixed(2);
  return formatCurrency(num)
}
// 百万
export const millionMoney = (state) =>{
  let num = state.colorStartMoney.toFixed(2)-660000000;
  return formatCurrency(num)
}

/**
 * 体育*/
// 体育首页游戏列表，过滤首页
export const sport_game_list = (state) => {
  return state.sports_navList.filter((item, index) => index > 0)
}



// WEBPACK FOOTER //
// ./src/common/store/getters.js